import { initializeApp} from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
// import { getNowTimeStamp } from '..path/to/firebase.utils';

const firebaseConfig = {
  apiKey: "AIzaSyBPNezaaWMZMC8Fs2xx-HmUUy6-hBW_0Bo",
  authDomain: "fgclone-414c4.firebaseapp.com",
  projectId: "fgclone-414c4",
  storageBucket: "fgclone-414c4.appspot.com",
  messagingSenderId: "245688506232",
  appId: "1:245688506232:web:01dc0adbdb304350d41a8d",
  measurementId: "G-V2SW6L8SC0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const firestore = getFirestore();
// export const timestamp = firebase.firestore.FieldValue.serverTimestamp;

// export const storeStorage = getStorage(app, "gs://storeimages-12")